var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroRightMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eL1pmPZMFhN1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-647-.930497)",
    clipPath: "url(#eL1pmPZMFhN5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "eL1pmPZMFhN4",
    d: "M366.0384,156.08996h172.168v72.033",
    transform: "matrix(.528486 0 0 0.528486 503.669955-4.494181)",
    fill: "none",
    stroke: "#002a2a",
    strokeWidth: 28,
    strokeDashoffset: 244.201,
    strokeDasharray: 244.201
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eL1pmPZMFhN5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1145,
    height: 556,
    rx: 0,
    ry: 0,
    transform: "translate(.893799 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroRightMobile);
export default __webpack_public_path__ + "static/media/hero-right-mobile.1aea1a437f930d3d165d12adeb86f1ab.svg";
export { ForwardRef as ReactComponent };